'use strict';

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _clsx = require('clsx');

var _clsx2 = _interopRequireDefault(_clsx);

var _NotifyItem = require('./NotifyItem.style');

var _NotifyItem2 = _interopRequireDefault(_NotifyItem);

var _Icon = require('../../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Label = require('../../Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AUTO_HIDE_TIMEOUT = 5000;
var NotifyItem = (_dec = (0, _reactJss2["default"])(_NotifyItem2["default"]), _dec(_class = function (_PureComponent) {
  (0, _inherits3["default"])(NotifyItem, _PureComponent);

  function NotifyItem(props) {
    (0, _classCallCheck3["default"])(this, NotifyItem);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (NotifyItem.__proto__ || (0, _getPrototypeOf2["default"])(NotifyItem)).call(this, props));

    _this.handleClose = _this.handleClose.bind(_this);
    return _this;
  }

  (0, _createClass3["default"])(NotifyItem, [{
    key: 'handleClose',
    value: function handleClose() {
      var _props = this.props,
          onClose = _props.onClose,
          id = _props.id;
      onClose({
        id: id
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.handleClose, AUTO_HIDE_TIMEOUT);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          classes = _props2.classes,
          className = _props2.className,
          label = _props2.label,
          icon = _props2.icon,
          type = _props2.type,
          helperText = _props2.helperText;
      return _react2["default"].createElement('div', {
        id: id,
        className: (0, _clsx2["default"])(classes.notifyItem, classes[type], className)
      }, _react2["default"].createElement('div', {
        className: (0, _clsx2["default"])(classes.titleContainer)
      }, icon ? _react2["default"].createElement(_Icon2["default"], {
        className: classes.icon,
        type: icon,
        size: 'medium',
        color: 'currentColor'
      }) : null, _react2["default"].createElement(_Label2["default"], {
        className: (0, _clsx2["default"])(classes.title),
        value: label,
        fontSize: 'medium'
      }), _react2["default"].createElement(_Icon2["default"], {
        className: (0, _clsx2["default"])(classes.closeIcon),
        type: 'close',
        size: 'micro',
        color: 'currentColor',
        onClick: this.handleClose
      })), helperText ? _react2["default"].createElement('div', {
        className: (0, _clsx2["default"])(classes.descriptionContainer)
      }, _react2["default"].createElement(_Label2["default"], {
        className: (0, _clsx2["default"])(classes.description),
        value: helperText,
        fontSize: 'medium'
      })) : null);
    }
  }]);
  return NotifyItem;
}(_react.PureComponent)) || _class);
NotifyItem.defaultProps = {
  type: 'normal',
  onClose: function onClose() {}
};
NotifyItem.propTypes = {
  classes: _propTypes2["default"].object,

  /** additional external class name */
  className: _propTypes2["default"].string,

  /** Notify's types */
  type: _propTypes2["default"].oneOf(['normal', 'error', 'success']),

  /** Notify's id */
  id: _propTypes2["default"].string.isRequired,

  /** Icon element */
  icon: _propTypes2["default"].string,

  /** Notify's label */
  label: _propTypes2["default"].string.isRequired,

  /** Notify's description */
  helperText: _propTypes2["default"].string,

  /** onClose callback */
  onClose: _propTypes2["default"].func
};
exports["default"] = NotifyItem;